/* unplugin-vue-components disabled */import script from "./ActorResumeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ActorResumeCard.vue?vue&type=script&setup=true&lang=js"

import "./ActorResumeCard.vue?vue&type=style&index=0&id=3c8f023a&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c8f023a"]])

export default __exports__